import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-error-page-utf',
    templateUrl: './error-page-utf.component.html',
    styleUrls: ['./error-page-utf.component.scss'],
    standalone: false
})
export class ErrorPageUtfComponent extends CfetBaseComponent implements OnInit {

  constructor(private cfetService: CfetService) { super(); }

  ngOnInit () {
    window.scrollTo(0, 0);
    this.cfetService.isLandingPage.next(true);
  }

}

